import React, { Component } from 'react';

class TemplateViewContainer extends Component {
  render() {
    const className = ['template-view-container', this.props.className]
      .filter(Boolean)
      .join(' ');
    return <div className={className}>{this.props.children}</div>;
  }
}

export default TemplateViewContainer;
